import createReactClass from 'create-react-class'
import React from 'react'
import SearchFormPanel from './search-form-panel'
import SearchResult from './search-result'
import './search-panel.scss'

export default createReactClass({
  render () {
    return (
      <div className="container search-panel">
        <div className="csc-panel">
          <div className="panel-body">
            <div className="card-title">Search Criteria</div>
            <SearchFormPanel {...this.props} />
          </div>
        </div>
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Search Results</h4>
            <SearchResult {...this.props}/>
          </div>
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/search-panel.js